import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useStatus, SUCCESS, ERROR } from '@rootstrap/redux-tools';

import useToast from 'hooks/useToast';
import { reportEpisode } from 'state/actions/seriesActions';
import useAnalytics from 'hooks/useAnalytics';
import { MIXPANEL_EVENTS } from 'constants/constants';
import { replaceError } from 'utils/helpers';

export default () => {
  const dispatch = useDispatch();
  const { trackEvent } = useAnalytics();
  const { status, error } = useStatus(reportEpisode);

  const { showErrorToast, showToast } = useToast();

  useEffect(() => {
    if (status === SUCCESS) {
      trackEvent(MIXPANEL_EVENTS.reportContent);
      showToast('The content was successfully reported!');
      dispatch(reportEpisode.reset());
    }
    if (status === ERROR) {
      showErrorToast(replaceError(error, /^reason /));
      dispatch(reportEpisode.reset());
    }
  }, [dispatch, showErrorToast, showToast, status, error]);

  return useCallback(({ episodeId, params }) => dispatch(reportEpisode({ episodeId, params })), [
    dispatch
  ]);
};
